import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, DoCheck } from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';
import { GeocodingService } from 'src/app/services/geocoding.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-map-picker',
  standalone: true,
  imports: [CommonModule, GoogleMapsModule],
  templateUrl: './map-picker.component.html',
  styleUrls: ['./map-picker.component.css']
})
export class MapPickerComponent implements OnInit, OnChanges, DoCheck {
  @Input() direccion: any;
  @Input() lat: number | null = null;
  @Input() lng: number | null = null;
  @Output() locationSelected = new EventEmitter<{ lat: number; lng: number }>();

  zoom = 15;
  center: google.maps.LatLngLiteral = { lat: -33.335, lng: -60.217 }; // fallback
  marker: google.maps.LatLngLiteral | null = null;

  private lastAddress: string | null = null;

  constructor(private geocoding: GeocodingService) {}

  ngOnInit(): void {
    // Si ya viene con coordenadas guardadas
    if (this.lat && this.lng) {
      this.setMarker(this.lat, this.lng);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['lat'] && this.lat) && (changes['lng'] && this.lng)) {
      this.setMarker(this.lat, this.lng);
      return;
    }
  }

  ngDoCheck(): void {
    // Verificar si hay dirección cargada
    if (this.direccion?.calle && this.direccion?.numero) {
      const fullAddress = `${this.direccion.calle} ${this.direccion.numero}, San Nicolás de Los Arroyos, Argentina`;

      if (this.lastAddress !== fullAddress) {
        this.lastAddress = fullAddress;

        this.geocoding.geocodeAddress(fullAddress).subscribe(results => {
          if (results?.length > 0) {
            const loc = results[0].geometry.location;
            this.setMarker(loc.lat(), loc.lng());
          }
        });
      }
    }
  }

  private setMarker(lat: number, lng: number) {
    this.center = { lat, lng };
    this.marker = this.center;
    this.locationSelected.emit(this.center); // emitir coordenadas al padre
  }

  moveMarker(event: google.maps.MapMouseEvent) {
    if (!event.latLng) return;
    this.setMarker(event.latLng.lat(), event.latLng.lng());
  }
}
